import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    avatarWrapper: {
      position: "relative",
    },
    defaultAvatar: {
      background: theme.palette.background.secondary_hover,
      border: `1px solid ${theme.palette.border.avatarContrast}`,
      height: "56px",
      width: "56px",

      "& img": {
        height: "48px",
        width: "48px",
      },
    },
    avatar: {
      background: theme.palette.background.secondary_hover,
      border: `1px solid ${theme.palette.border.avatarContrast}`,
      height: "56px",
      width: "56px",
      "& img": {
        objectFit: "contain",
      },
    },
    contactDetailsContainer: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
      "& *": {
        fontSize: "18px",
        fontWeight: 600,
        color: theme.palette.text.secondary,
      },
      "& * + *": {
        fontSize: "16px",
        fontWeight: 400,
        color: theme.palette.text.tertiary,
      },
    },
    contactDetails: {
      display: "flex",
      gap: "4px",
      flexDirection: "column",
    },
    agentCard: {
      padding: "24px",
      borderRadius: "12px !important",
      maxWidth: "433px",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    verifiedIcon: {
      position: "absolute",
      bottom: 0,
      right: 0,
      fill: "#2E90FA",
    },
  };
});
